import { render, staticRenderFns } from "./KDS.vue?vue&type=template&id=b4ab6444"
import script from "./KDS.vue?vue&type=script&lang=js"
export * from "./KDS.vue?vue&type=script&lang=js"
import style0 from "./KDS.vue?vue&type=style&index=0&id=b4ab6444&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports